const travellers = {
  title: 'Traveller Information',
  modal: {
    title: 'Edit travelers details.',
    actions: {
      save: 'Update',
    },
  },
  actions: {
    quote: 'Get a quote',
  },
  maxTravellersModal: {
    title: 'Maximum number of travellers.',
    content:
      'Unfortunately, we only support up to {{maxSecondaryTravellers}} additional travellers per policy. You can always get two different policies if you wish to add more.',
    actions: {
      ok: 'Ok, got it',
    },
  },
  additionalTravellers: {
    title: 'Additional travellers',
    actions: {
      add: 'Add',
      remove: 'Remove',
    },
  },
  dependent: {
    checkbox: {
      label: 'Is this traveller an accompanied child?',
    },
    actions: {
      info: 'More info',
    },
    modal: {
      title: 'What is an Accompanied Child?',
      content:
        'An accompanied child means your child or grandchild who is identified on the Certificate of Insurance and travelling with you on the journey, provided they are not in full-time employment, they are financially dependent on you and they are under the age of 21 years.',
      actions: {
        ok: 'Ok, got it',
      },
    },
  },
  residentStatus: {
    title: 'Residency Status',
    checkbox: {
      label:
        'All travellers are Australian citizens OR currently living in Australia with a visa allowing them to live and work.',
    },
    modal: {
      title: 'What exactly is a Resident?',
      subtitle: 'The Traveller must be currently living in Australia, and:',
      content: [
        'are Australian citizens with a valid Australian Medicare card, or',
        'they hold a visa allowing them to live and work in Australia and requires them to maintain a minimum level of health insurance coverage.',
      ],
      actions: {
        ok: 'Ok, got it',
      },
    },
  },
} as const;

export default travellers;
